import { HARVEST_PROOF_MAX_DISTANCE_METERS } from './field-proximity';

export const PROXIMITY_BAR_MAX_METERS = 100;

export interface ProximityUi {
  value: number;
  color: string;
  meters: number | null;
  isBeyondRange: boolean;
}

/** Linear mapping: 0 m => 100 %, 100 m+ => 0 %. */
export function computeProximityUi(meters: number | null): ProximityUi {
  const barMeters =
    meters === null
      ? null
      : Math.max(0, Math.min(PROXIMITY_BAR_MAX_METERS, meters));
  const value =
    barMeters === null ? 0 : Math.round((1 - barMeters / PROXIMITY_BAR_MAX_METERS) * 100);
  const color =
    meters === null
      ? '#adb5bd'
      : meters <= HARVEST_PROOF_MAX_DISTANCE_METERS
        ? '#40c057'
        : meters <= PROXIMITY_BAR_MAX_METERS
          ? '#f59f00'
          : '#e03131';

  return {
    value,
    color,
    meters,
    isBeyondRange: meters !== null && meters > PROXIMITY_BAR_MAX_METERS,
  };
}

export function formatProximityDistanceLabel(proximity: ProximityUi): string {
  if (proximity.meters === null) {
    return 'Recherche du signal GPS…';
  }

  if (proximity.meters <= HARVEST_PROOF_MAX_DISTANCE_METERS) {
    return `Sur la parcelle (${Math.round(proximity.meters)} m)`;
  }

  if (proximity.isBeyondRange) {
    return `+${PROXIMITY_BAR_MAX_METERS} m de la parcelle`;
  }

  return `${Math.round(proximity.meters)} m de la parcelle`;
}
